import React from 'react';

import { GroupList, GroupToolbar } from 'views/Group/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <GroupToolbar />
      <div className={classes.content}>
        <GroupList />
      </div>
    </div>
  );
};
